
  export const headers = {
    initialHeaders: [
      { title: "Nombre", field: "denomination", child: null },
      { title: "¿Quién aprueba?", field: "chargeApprovers", child: null },
      { title: "Estado", field: "status", child: null },
    ],
  };
  